import { render, staticRenderFns } from "./ForumGroupSettings.vue?vue&type=template&id=cae2561a&scoped=true&"
import script from "./ForumGroupSettings.vue?vue&type=script&lang=js&"
export * from "./ForumGroupSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae2561a",
  null
  
)

export default component.exports